<template>
  <v-container
    id="lista-informacoes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-card
      class="mx-auto"
      outlined
    >
      <v-list-item three-line>
        <v-list-item-content
          id="listItemListaPaginas"
          class="pr-10"
          :style="dynamicPaddingListaPaginas"
        >
          <div class="text-overline mb-4 highlighted-item">
            Lista Páginas Contratos
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-card-actions>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="6"
            lg="6"
          >
            <div
              v-if="loadingPaginas"
              :style="styleObject"
              class="text-center"
            >
              <v-icon
                light
                class="custom-loader"
                :style="styleObject"
              >
                mdi-cached
              </v-icon>
              Carregando dados...
            </div>
            <div
              v-else-if="error"
              class="alert alert-danger"
            >
              {{ error }}
            </div>
            <div
              v-else
            >
              <v-data-table
                id="headers"
                :headers="headers"
                :items="informacoes"
                :items-per-page="informacoes.length"
                :page.sync="page"
                hide-default-footer
                disable-sort
                class="elevation-1"
                style="color: black"
                item-key="id"
              >
                <template v-slot:top>
                  <v-container>
                    <v-row>
                      <v-col
                        id="buscaPagina"
                        cols="12"
                        sm="4"
                        md="4"
                        lg="4"
                      >
                        <tex-field-with-validation
                          v-model="moduloSelect"
                          label="Buscar Modulo ..."
                          @keyup.enter="filtrarPagina()"
                        />
                      </v-col>
                      <v-col
                        id="buscaPagina"
                        cols="12"
                        sm="4"
                        md="4"
                        lg="4"
                      >
                        <tex-field-with-validation
                          v-model="paginaSelect"
                          label="Buscar Páginas ..."
                          @keyup.enter="filtrarPagina()"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="1"
                        md="1"
                        lg="1"
                      >
                        <v-btn
                          id="btnBuscaPagina"
                          small
                          class="v-btn--block"
                          :color="corPrimaria"
                          @click="filtrarPagina()"
                        >
                          Buscar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
                <template v-slot:item="{ item }">
                  <tr @click="editar(item)">
                    <td
                      v-for="(header, index) in headers"
                      :key="index"
                      :style="{ backgroundColor: (paginaId === item.id && (informacoes.length > 1)) ? '#BBDEFB' : '' }"
                    >
                      {{ item[header.value] }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <br>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <div class="d-flex justify-space-between align-center pa-2">
                    <v-pagination
                      v-model="page"
                      :length="totalPaginas"
                      :total-visible="totalPaginas"
                      @input="onPageChangePaginas"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="6"
          >
            <div
              v-if="loadingPaginasRelacao"
              :style="styleObject"
              class="text-center"
            >
              <v-icon
                light
                class="custom-loader"
                :style="styleObject"
              >
                mdi-cached
              </v-icon>
              Carregando dados...
            </div>
            <div
              v-else-if="error"
              class="alert alert-danger"
            >
              {{ error }}
            </div>
            <div
              v-else
            >
              <v-data-table
                v-if="exibirTable"
                id="headers"
                :headers="headersListaPagina"
                :items="listaContratoPagina"
                :items-per-page="listaContratoPagina.length"
                hide-default-footer
                disable-sort
                fixed-header
                class="elevation-1"
                style="color: black"
                item-key="id"
              >
                <template v-slot:top>
                  <v-container>
                    <v-row>
                      <v-col
                        id="buscaPagina"
                        cols="12"
                        sm="4"
                        md="4"
                        lg="4"
                      >
                        <tex-field-with-validation
                          v-model="contratoSelect"
                          label="Buscar Contrato ..."
                          @keyup.enter="filtrarContrato()"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                      >
                        <v-btn
                          id="btnBuscaPagina"
                          small
                          class="v-btn--block"
                          :color="corPrimaria"
                          @click="filtrarContrato()"
                        >
                          Buscar
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                      >
                        <v-btn
                          id="btnBuscaPagina"
                          small
                          :color="corPrimaria"
                          dark
                          @click="cadastrar()"
                        >
                          <v-icon>
                            mdi-update
                          </v-icon>
                          Cadastrar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
                <template v-slot:[`item.remover`]="{ item }">
                  <v-icon
                    class="text-h3"
                    :color="corError"
                    @click="remove(item)"
                  >
                    mdi-trash-can
                  </v-icon>
                </template>
              </v-data-table>
              <br>
              <v-row v-if="exibirTable">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <div class="d-flex justify-space-between align-center pa-2">
                    <v-pagination
                      v-model="pageContratoPagina"
                      :length="totalContratoPaginas"
                      :total-visible="totalContratoPaginas"
                      @input="onPageChangeContratoPaginas"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="dialog.visible"
      transition="dialog-bottom-transition"
      persistent
      max-width="700px"
      @keydown.esc="dialog.visible = false"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-icon
            aria-label="Close"
            @click="dialog.visible = false, excluirPagina = true"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="text-center">
          <h4>{{ dialog.message }}</h4>
        </v-card-text>
        <v-card-text class="pb-3 pt-6 text-center">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                class="text-center"
              >
                <v-select
                  v-model="selectContrato"
                  :items="filterContratos.length > 0 ? filterContratos : listaContrato"
                  item-value="id"
                  item-text="nome"
                  label="Contratos"
                  multiple
                  return-object
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.nome }}, </span>
                    </v-chip>
                    <v-chip v-if="index === 1">
                      <span>{{ item.nome }}, </span>
                    </v-chip>
                    <span
                      v-if="index === 2"
                      class="grey--text text-caption"
                    >
                      (+{{ selectContrato.length - 2 }} outros)
                    </span>
                  </template>
                  <template v-slot>
                    Selecione Contrato
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-item>
                      <v-list-item-action>
                        <input
                          id="filtroContrato"
                          v-model="filtroContrato"
                          prepend-inner-icon="mdi-account-search"
                          placeholder="Filtrar Contrato"
                          @change="filterContratoToggle"
                        >
                      </v-list-item-action>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      /><br>
                    </v-list-item>
                    <v-list-item
                      slot="prepend-item"
                      ripple
                      @click="toggleContrato"
                    >
                      <v-list-item-action>
                        <v-icon :color="selectContrato.length > 0 ? 'indigo darken-4' : ''">
                          {{ iconContrato }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-title id="idSelecTotos">
                        Selecionar todas
                      </v-list-item-title>
                    </v-list-item>
                    <v-divider
                      slot="prepend-item"
                      class="mt-2"
                    />
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col
                cols="4"
                lg="3"
              >
                <v-btn
                  id="btnBuscaPagina"
                  class="pa-2 ma-2"
                  small
                  :color="corPrimaria"
                  dark
                  @click="dialog.visible = false, excluirPagina = true"
                >
                  Fechar
                </v-btn>
              </v-col>
              <v-col
                cols="4"
                lg="3"
              >
                <v-btn
                  id="btnBuscaPagina"
                  class="pa-2 ma-2"
                  small
                  :color="corPrimaria"
                  dark
                  @click="atualizarPermissao(selectContrato)"
                >
                  <v-icon>
                    mdi-update
                  </v-icon>
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    >
      {{ snackbar.message }}
    </dashboard-core-snackbar>
  </v-container>
</template>

<script>
  import Menu from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'PageListaUsuarios',
    emits: ['enablePermissao', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },
    data: () => ({
      appOnline: navigator.onLine,
      styleObjectError: {
        color: localStorage.corError,
      },
      corPrimaria: localStorage.corPrimaria,
      corError: localStorage.corError,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      headers: [
        { text: 'Modulo', value: 'modulo', width: '12%', class: 'black--text title' },
        { text: 'Página', value: 'pagina', width: '22%', class: 'black--text title' },
        { text: 'Url', value: 'url', width: '22%', class: 'black--text title' },
        { text: 'Descricão', value: 'descricao', width: '44%', class: 'black--text title' },
      ],
      headersListaPagina: [
        { text: 'Contrato', value: 'contrato', class: 'black--text title' },
        { text: 'Nome', value: 'nome', class: 'black--text title' },
        { text: 'Remover Permissão', value: 'remover', align: 'center', class: 'black--text title' },
      ],
      headersListaContrato: [
        { text: 'Contrato', value: 'contrato', class: 'black--text title' },
        { text: 'Nome', value: 'nome', class: 'black--text title' },
      ],
      informacoes: [],
      paginaEnable: false,
      listaContratoPagina: [],
      listaContrato: [],
      selectContrato: [],
      exibirTable: false,
      paginaId: 0,
      dialog: {
        visible: false,
        message: '',
      },
      filterContratos: [],
      filtroContrato: '',
      moduloSelect: '',
      paginaSelect: '',
      paginaFiltered: [],
      dynamicPaddingListaPaginas: '',
      contratoSelect: '',
      listaContratoPaginaFilter: [],
      exibirPaginaFiltradas: false,
      page: 1,
      totalPaginas: 0,
      pageContratoPagina: 1,
      totalContratoPaginas: 0,
      totalContratoPaginasFiltros: 0,
      loadingPaginas: false,
      loadingPaginasRelacao: false,
      error: null,
    }),

    computed: {
      likesAllContrato () {
        return this.selectContrato.length === this.listaContrato.length
      },

      likesSomeContrato () {
        return this.selectContrato.length > 0 && !this.likesAllContrato
      },

      iconContrato () {
        if (this.likesAllContrato) return 'mdi-close-box'
        if (this.likesSomeContrato) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },
    },

    beforeDestroy () {
      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      eventEmit.$emit('atualizar_texto', 'Páginas')

      this.updateDynamicPadding()

      window.addEventListener('resize', this.updateDynamicPadding)

      Menu.verificarPermissaoPaginaUsuario(localStorage.username, window.location.href, localStorage.tokencontrato).then(resposta => {
        if (resposta.data.status) {
          this.paginaEnable = true

          this.showPaginasContrato()
        } else {
          this.$router.push('/dashboard')
        }
      }).catch(e => {
        if (e.message === 'Network Error') {
          this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
        }
      })
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingListaPaginas = 'padding-right: 110rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingListaPaginas = 'padding-right: 80rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingListaPaginas = 'padding-right: 20rem !important'
        } else if (window.innerWidth > 600 && window.innerWidth < 1000) {
          this.dynamicPaddingListaPaginas = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingListaPaginas = 'padding-right: 70rem !important'
        }
      },

      toggleContrato () {
        this.$nextTick(() => {
          if (this.likesAllContrato) {
            this.selectContrato = []
          } else {
            if (this.filterContratos.length > 0) {
              this.selectContrato = this.filterContratos
            } else {
              this.selectContrato = this.listaContrato.slice()
            }
          }
        })
      },

      filterContratoToggle () {
        if (this.filtroContrato.length > 0) {
          for (let i = 0; i < this.listaContrato.length; i++) {
            if (this.listaContrato[i].nome.toLowerCase().includes(this.filtroContrato.toLowerCase())) {
              this.filterContratos.push(this.listaContrato[i])
            }
          }
        } else {
          this.filterContratos = []
        }
      },

      cadastrar () {
        this.showDialog('Inserir Permissões')
      },

      showDialog (message) {
        this.dialog.visible = true
        this.dialog.message = message
      },

      atualizarPermissao () {
        if (confirm('Tem certeza que deseja confirmar as alterações?')) {
          const paginaIdTemp = this.paginaId

          Menu.atualizarPermissao(this.selectContrato, this.paginaId).then(resposta => {
            if (resposta.data.status) {
              this.paginaId = paginaIdTemp
              this.selectContrato.forEach((contrato) => {
                this.listaContratoPagina.push(contrato)
              })

              const indicesParaRemover = []

              this.listaContratoPagina.forEach((item) => {
                const index = this.listaContrato.findIndex((element) => element.id === item.id)

                if (index !== -1) {
                  indicesParaRemover.push(index)
                }
              })

              indicesParaRemover.forEach((index) => {
                this.listaContrato.splice(index, 1)
              })

              this.selectContrato = []

              this.showSnackbar('success', 3000, 'Permissões atualizadas com sucesso!')

              this.dialog.visible = false
            } else {
              this.showSnackbar('error', 3000, 'Erro ao atualizar Permissões.')
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          })
        }
      },

      remove (item) {
        if (confirm('Tem certeza que deseja remover este item?')) {
          Menu.removerPermissao(item.contrato, item.paginaId).then(resposta => {
            if (resposta.data.status) {
              const index = this.listaContratoPagina.indexOf(item)

              if (index !== -1) {
                this.listaContratoPagina.splice(index, 1)

                if (this.contratoSelect.length > 0) {
                  this.listaContratoPaginaFilter = this.listaContratoPagina.filter(item =>
                    this.contratoSelect.split(',').some(contrato => item.nome.toLowerCase().includes(contrato.toLowerCase())),
                  )
                }

                this.listaContrato.push(item)
              }

              this.showSnackbar('success', 3000, 'Permissões atualizadas com sucesso!')
            } else {
              this.showSnackbar('error', 3000, 'Erro ao atualizar Permissões.')
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          })
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      async showPaginasContrato () {
        this.exibirTable = false

        this.paginaId = 1

        this.listaContratoPagina = []

        this.listaContrato = []

        this.selectContrato = []

        this.listaContratoPaginaFilter = []

        this.contratoSelect = ''

        this.pageContratoPagina = 1

        this.loadingPaginas = true

        await Menu.showPaginasContrato(this.page, this.moduloSelect, this.paginaSelect).then(resposta => {
          if (resposta.data.status) {
            this.informacoes = resposta.data.dados

            this.totalPaginas = resposta.data.totalPaginas
          } else {
            this.informacoes = []
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingPaginas = false
        })
      },

      onPageChangePaginas () {
        this.showPaginasContrato()
      },

      filtrarPagina () {
        if (this.moduloSelect.length > 0 || this.paginaSelect.length > 0) {
          this.page = 1

          this.showPaginasContrato()
        } else {
          this.page = 1

          this.showPaginasContrato()
        }
      },

      async buscarPaginasFiltro () {
        this.loadingPaginas = true

        await Menu.showPaginasContrato(this.page, this.moduloSelect, this.paginaSelect).then(resposta => {
          if (resposta.data.status) {
            this.informacoes = resposta.data.dados

            this.totalPaginas = resposta.data.totalPaginas
          } else {
            this.informacoes = []
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingPaginas = false
        })
      },

      async editar (item) {
        this.exibirTable = true

        this.paginaId = item.id

        this.listaContratoPagina = []

        this.listaContrato = item.contratos

        this.selectContrato = []

        this.listaContratoPaginaFilter = []

        this.contratoSelect = ''

        this.pageContratoPagina = 1

        this.loadingPaginasRelacao = true

        await Menu.showContratosVinculados(this.paginaId, this.pageContratoPagina, localStorage.tokencontrato, this.contratoSelect).then(resposta => {
          if (resposta.data.status) {
            this.listaContratoPagina = resposta.data.dados

            this.totalContratoPaginas = resposta.data.totalPaginasContrato
          } else {
            this.informacoes = []
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingPaginasRelacao = false
        })
      },

      onPageChangeContratoPaginas () {
        this.buscarDadosContratoPaginas()
      },

      async buscarDadosContratoPaginas () {
        this.loadingPaginasRelacao = true

        await Menu.showContratosVinculados(this.paginaId, this.pageContratoPagina, localStorage.tokencontrato, this.contratoSelect).then(resposta => {
          if (resposta.data.status) {
            this.listaContratoPagina = resposta.data.dados

            this.totalContratoPaginas = resposta.data.totalPaginasContrato
          } else {
            this.informacoes = []
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingPaginasRelacao = false
        })
      },

      filtrarContrato () {
        if (this.contratoSelect.length > 0) {
          this.pageContratoPagina = 1

          this.buscarDadosContratoPaginas()
        } else {
          this.pageContratoPagina = 1

          this.contratoSelect = ''

          this.buscarDadosContratoPaginas()
        }
      },
    },
  }
</script>

<style lang="sass">
  .horizontal-scroll
    overflow-x: auto
    white-space: nowrap

  #textoExibicao
    font-size: 12px

  #buscaPagina
    margin: -1.5rem 0 0 1rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemListaPaginas
    margin: -2rem 0 0 -1rem

  #btnBuscaPagina
    width: 130px !important
    max-width: 130px !important
    min-width: 130px !important
    border-radius: 10px !important

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
</style>
